<script lang="ts">
	import { t } from '$lib/translations';

	interface Props {
		exifInfo: Record<string, any>;
	}

	let { exifInfo }: Props = $props();

	let { model, fNumber, lensModel, focalLength, exposureTime } = $derived(exifInfo || {});

	let enoughToShowTheBox = $derived(!!model || !!fNumber || !!lensModel || !!focalLength || !!exposureTime);

	const formatExposureTime = (value) => {
		if (value < 1) {
			return `1/${Math.round(1 / value)}`;
		}
	};
</script>

{#if enoughToShowTheBox}
	<ul class="border-y text-sm">
		{#if model}
			<li class="border-b p-2">{$t('photograph.camera')}: {model}</li>
		{/if}
		{#if lensModel}
			<li class="border-b p-2">{$t('photograph.lens')}: {lensModel}</li>
		{/if}
		<li>
			<ul class="flex flex-row">
				{#if focalLength}
					<li class="p-2 basis-auto grow border-r border-dotted">
						{focalLength}mm
					</li>
				{/if}
				{#if fNumber}
					<li class="p-2 basis-auto grow border-r border-dotted">
						ƒ/{fNumber}
					</li>
				{/if}
				{#if exposureTime}
					<li class="p-2 basis-auto grow border-r border-dotted">
						{formatExposureTime(exposureTime)}s
					</li>
				{/if}
			</ul>
		</li>
	</ul>
{/if}
